<template>
  <div>
    <div class="panel panel-default panel-fill">
      <div class="panel-heading">
        <h3 class="panel-title">
          {{ trans("users.editProfileHeader") }}
        </h3>
      </div>
      <div class="panel-body">
        <form role="form">
          <div class="row">
            <div class="m-b-20 col-md-6">
              <div class="form-group" :class="{ 'has-error': errors.username }">
                <label for="username">{{ trans("users.usernameLabel") }}</label>
                <i v-if="!isNewUser" class="far fa-asterisk" />
                <input
                  id="username"
                  v-model="user.username"
                  type="text"
                  class="form-control"
                />
                <form-error v-if="errors.username" :errors="errors.username" />
              </div>
            </div>

            <div class="m-b-20 col-md-6">
              <div class="form-group" :class="{ 'has-error': errors.email }">
                <label for="email">{{ trans("users.emailLabel") }}</label>
                <i class="far fa-asterisk" />
                <input
                  id="email"
                  v-model="user.email"
                  type="email"
                  class="form-control"
                  autocomplete="email"
                />
                <form-error v-if="errors.email" :errors="errors.email" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="m-b-20 col-md-6">
              <div
                class="form-group"
                :class="{ 'has-error': errors.firstname }"
              >
                <label for="first_name">{{
                  trans("users.firstNameLabel")
                }}</label>
                <i class="far fa-asterisk" />
                <input
                  id="first_name"
                  v-model="user.firstname"
                  type="text"
                  name="first_name"
                  class="form-control"
                />
                <form-error
                  v-if="errors.firstname"
                  :errors="errors.firstname"
                />
              </div>
            </div>

            <div class="m-b-20 col-md-6">
              <div class="form-group" :class="{ 'has-error': errors.lastname }">
                <label for="last_name">{{
                  trans("users.lastNameLabel")
                }}</label>
                <i class="far fa-asterisk" />
                <input
                  id="last_name"
                  v-model="user.lastname"
                  type="text"
                  name="last_name"
                  class="form-control"
                />
                <form-error v-if="errors.lastname" :errors="errors.lastname" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="m-b-20 col-md-6">
              <div class="form-group" :class="{ 'has-error': errors.phone_no }">
                <label for="phone_no">{{
                  trans("users.contactNoLabel")
                }}</label>
                <i
                  v-if="$store.state.dermicusPlatform === 'stockholm'"
                  class="far fa-asterisk"
                />
                <input
                  id="phone_no"
                  v-model="user.phone_no"
                  type="text"
                  name="phone_no"
                  class="form-control"
                  :placeholder="trans('forms.phoneNumber')"
                />
                <form-error v-if="errors.phone_no" :errors="errors.phone_no" />
              </div>
            </div>

            <div class="m-b-20 col-md-6">
              <div class="form-group" :class="{ 'has-error': errors.title }">
                <label for="title">{{ trans("users.jobTitleLabel") }}</label>
                <input
                  id="title"
                  v-model="user.title"
                  type="text"
                  name="title"
                  class="form-control"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="m-b-20 col-md-6">
              <div class="form-group" :class="{ 'has-error': errors.comment }">
                <label for="comment">{{ trans("users.commentLabel") }}</label>
                <input
                  id="comment"
                  v-model="user.comment"
                  type="text"
                  name="comment"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </form>
        <span class="text-left"
          ><i class="far fa-asterisk" />
          {{ trans("center.requiredField") }}</span
        >
      </div>
    </div>

    <platform-attribute-editor
      :platform="user.platform"
      :platform-attributes="user.platform_attributes"
      :platform-attribute-values="user.platform_attribute_values ?? {}"
      :errors="errors"
    />

    <div class="panel panel-default panel-fill">
      <div class="panel-heading">
        <h3 class="panel-title">
          {{ trans("users.changePasswordHeadline") }}
        </h3>
      </div>
      <div class="panel-body">
        <form role="form">
          <input
            type="text"
            autocomplete="username"
            ng-hide="true"
            style="display: none"
          />
          <div class="m-b-20 col-md-12">
            <div class="m-b-20">
              <div
                v-if="ownProfile"
                class="form-group"
                :class="{ 'has-error': errors.current_password }"
              >
                <label for="CurrentPassword">{{
                  trans("users.currentPasswordLabel")
                }}</label>
                <div class="input-group" style="max-width: 600px">
                  <input
                    id="CurrentPassword"
                    v-model="user.current_password"
                    :type="showCurrentPassword ? 'text' : 'password'"
                    name="password"
                    class="form-control"
                  />
                  <div class="input-group-append">
                    <button
                      type="button"
                      class="btn btn-default"
                      data-test="user-form-current-password-toggle"
                      @click="showCurrentPassword = !showCurrentPassword"
                    >
                      <i
                        :class="
                          showCurrentPassword ? 'fa fa-eye-slash' : 'fa fa-eye'
                        "
                      ></i>
                    </button>
                  </div>
                </div>
                <form-error
                  v-if="errors.current_password"
                  :errors="errors.current_password"
                />
                <hr />
              </div>

              <div class="form-group" :class="{ 'has-error': errors.password }">
                <label for="Password">{{
                  trans("users.changePasswordLabel")
                }}</label>
                <div class="input-group" style="max-width: 600px">
                  <input
                    id="Password"
                    v-model="user.password"
                    :type="showNewPassword ? 'text' : 'password'"
                    name="password"
                    class="form-control"
                    autocomplete="new-password"
                  />
                  <div class="input-group-append">
                    <button
                      type="button"
                      class="btn btn-default"
                      data-test="user-form-new-password-toggle"
                      @click="showNewPassword = !showNewPassword"
                    >
                      <i
                        :class="
                          showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'
                        "
                      ></i>
                    </button>
                  </div>
                </div>
                <small class="form-text text-muted">{{
                  trans("auth.recommendedPasswordLength")
                }}</small>
                <form-error v-if="errors.password" :errors="errors.password" />
              </div>

              <div
                class="form-group"
                :class="{ 'has-error': errors.password_confirmation }"
              >
                <label for="RePassword">{{
                  trans("users.repeatChangePasswordLabel")
                }}</label>
                <div class="input-group" style="max-width: 600px">
                  <input
                    id="RePassword"
                    v-model="user.password_confirmation"
                    :type="showRepeatPassword ? 'text' : 'password'"
                    name="password_confirmation"
                    class="form-control"
                    autocomplete="new-password"
                  />
                  <div class="input-group-append">
                    <button
                      type="button"
                      class="btn btn-default"
                      data-test="user-form-repeat-password-toggle"
                      @click="showRepeatPassword = !showRepeatPassword"
                    >
                      <i
                        :class="
                          showRepeatPassword ? 'fa fa-eye-slash' : 'fa fa-eye'
                        "
                      ></i>
                    </button>
                  </div>
                </div>
                <form-error
                  v-if="errors.password_confirmation"
                  :errors="errors.password_confirmation"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import PlatformAttributeEditor from "../../../PlatformAttributes/PlatformAttributesEditor.vue";

export default {
  components: {
    PlatformAttributeEditor,
  },
  props: {
    ownProfile: {
      type: Boolean,
      default: false,
    },
    isNewUser: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    user: {
      type: Object,
      required: true,
    },
    platform: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showCurrentPassword: false,
      showNewPassword: false,
      showRepeatPassword: false,
      dermicusPlatform: this.$store.state.dermicusPlatform,
    };
  },
};
</script>
